import { API_PREFIX_V1 } from "../constants";

// App
export const ROUTE_DASHBOARD = `/home`;
export const ROUTE_MISSING_STAFF_FIELDS = `/dashboard/missing-fields/:field`;
export const API_MISSING_STAFF_FIELDS = `${API_PREFIX_V1}dashboard/missing-fields`;
export const ROUTE_MANAGE_STAFF = `/manage-staff`;
export const ROUTE_STAFF_EXPORT = `/manage-staff/export`;
export const ROUTE_STAFF_DASHBOARD = `/staff-dashboard`;
export const ROUTE_STAFF_PROFILE = `/manage-staff/:staffId`;
export const ROUTE_MANAGE_DEPARTMENT = `/manage-department`;
export const ROUTE_MANAGE_SUB_DEPARTMENT = `/manage-sub-department`;
export const ROUTE_MANAGE_DEAL_STAGE = `/manage-deal-stage`;
export const ROUTE_MANAGE_DEAL_SUB_STAGE = `/manage-deal-sub-stage`;
export const ROUTE_MANAGE_PROJECT = `/manage-project`;
export const ROUTE_PROJECT_DASHBOARD = `/project-dashboard`;
export const ROUTE_PROJECT_EXPORT = `/manage-project/export`;
export const ROUTE_MILESTONES = `/milestones`;
export const ROUTE_MILESTONE_EXPORT = `/milestones/export`;
export const ROUTE_MANAGE_BILLING_CYCLE = `/manage-billing-cycle`;
export const ROUTE_MANAGE_VENDOR = `/manage-vendor`;
export const ROUTE_BILLING_SUMMARY = `/billing-summary`;
export const ROUTE_ALLOCATION_REPORT = `/allocation-report`;
export const ROUTE_REPORTS = `/reports`;
export const ROUTE_REPORT_BUILDER = `/reports/new`;
export const ROUTE_REPORT_DETAILS = `/reports/edit/:reportId`;
export const ROUTE_MANAGE_ACCOUNT = `/manage-client`;
export const ROUTE_MANAGE_FOREX = `/manage-forex`;
export const ROUTE_MANAGE_SALES = `/manage-sales`;
export const ROUTE_SALES_DASHBOARD = `/sales-dashboard`;
export const ROUTE_SALES_WON = `/manage-sales/won`;
export const ROUTE_SALES_LOST = `/manage-sales/lost`;
export const ROUTE_SALES_EXPORT = `/manage-sales/export`;
export const ROUTE_MANAGE_IT = `/manage-it`;
export const ROUTE_IT_DASHBOARD = `/it-dashboard`;
export const ROUTE_EXPORT_IT_ASSETS = `/manage-it/export`;
export const ROUTE_MANAGE_USERS = `/manage-users`;
export const ROUTE_MANAGE_ROLES = `/manage-roles`;
export const ROUTE_MANAGE_EMAIL = `/manage-email`;
export const ROUTE_MANAGE_DOCUMENT_TYPE = `/manage-document-type`;
export const ROUTE_MANAGE_DOCUMENT_SUB_TYPE = `/manage-document-sub-type`;
export const ROUTE_MANAGE_RELEASE = `/manage-release`;

// AI Candidate Screening & Ranking module
export const ROUTE_CANDIDATE_SCREENING = `/candidate-screening`;
export const ROUTE_RESUME_MASTER = `/candidate-screening/resume-master`;
export const ROUTE_SCREENING_RESULTS = `/screening-results`;
export const ROUTE_SCREENING_RULES = `/screening-rules`;
export const ROUTE_SCREENING_AI_CONFIG = `/screening-ai-config`;
export const API_GET_DASHBOARD_SUMMARY_COUNTS = `${API_PREFIX_V1}dashboard/summary-counts`;
export const API_GET_DASHBOARD_BENCH_PEOPLE = `${API_PREFIX_V1}dashboard/bench-people`;
export const API_GET_DASHBOARD_BENCH_FY_STAFF = `${API_PREFIX_V1}dashboard/bench-fy-staff`;

export const API_GET_DASHBOARD_LOW_PROJECT_ASSIGNMENT = `${API_PREFIX_V1}dashboard/low-project-assignment`;

export const API_GET_STAFF_LIST = `${API_PREFIX_V1}staffs/staff-list`;
export const API_CREATE_STAFF = `${API_PREFIX_V1}staffs/create-staff`;
export const API_DELETE_STAFF = `${API_PREFIX_V1}staffs/delete-staff/`;
export const API_UPDATE_STAFF = `${API_PREFIX_V1}staffs/update-staff/`;
export const API_APPROVE_STAFF = `${API_PREFIX_V1}staffs/approve/`;
export const API_REJECT_STAFF = `${API_PREFIX_V1}staffs/reject/`;
export const API_GET_ALL_STAFF_LIST = `${API_PREFIX_V1}staffs/get-staff-list`;
export const API_GET_STAFF_DETAILS = `${API_PREFIX_V1}staffs/get-staff-by-Id`;
export const API_RESOLVE_STAFF_EMPLOYEE_ID = `${API_PREFIX_V1}staffs/resolve-employee-id/`;
export const API_GET_STAFF_EMPLOYEE_ID_HISTORY = `${API_PREFIX_V1}staffs/employee-id-history/`;
export const API_STAFF_BULK_IMPORT = `${API_PREFIX_V1}staffs/staff-bulk-import`;
export const API_GET_STAFF_SALARY_INFO = `${API_PREFIX_V1}staffs/staff-salary/`;
export const API_CREATE_STAFF_SALARY_INFO = `${API_PREFIX_V1}staffs/staff-salary-revision`;
export const API_UPDATE_STAFF_SALARY_INFO = `${API_PREFIX_V1}staffs/staff-salary-revision/`;

export const API_GET_DEPARTMENT_LIST = `${API_PREFIX_V1}departments/departments-list`;
export const API_CREATE_DEPARTMENT = `${API_PREFIX_V1}departments/create-departments`;
export const API_DELETE_DEPARTMENT = `${API_PREFIX_V1}departments/delete-department/`;
export const API_UPDATE_DEPARTMENT = `${API_PREFIX_V1}departments/update-department/`;
export const API_GET_ALL_DEPARTMENT_LIST = `${API_PREFIX_V1}departments/get-department-list`;

export const API_CREATE_SUB_DEPARTMENT = `${API_PREFIX_V1}departments/sub-department/create`;
export const API_GET_SUB_DEPARTMENT_LIST = `${API_PREFIX_V1}departments/sub-departments/list`;
export const API_DELETE_SUB_DEPARTMENT = `${API_PREFIX_V1}departments/delete-sub-department/`;
export const API_UPDATE_SUB_DEPARTMENT = `${API_PREFIX_V1}departments/update-sub-department/`;
export const API_GET_SUBDEPARTMENTS_BY_DEPARTMENT = `${API_PREFIX_V1}departments/get-sub-departments/`;

export const API_GET_ALL_PROJECT_LIST = `${API_PREFIX_V1}projects/get-project-list`;
export const API_GET_ALL_PROJECT_LIST_MILESTONES = `${API_PREFIX_V1}projects/get-project-list/for-milestone-filter`;
export const API_GET_PROJECT_DETAILS = `${API_PREFIX_V1}projects/get-project/`;
export const API_GET_PROJECT_LIST = `${API_PREFIX_V1}projects/projects-list`;
export const API_GET_ACTIVE_CONTRACT_EXPIRY_LIST = `${API_PREFIX_V1}projects/active-contracts-expiry-list`;
export const API_DELETE_PROJECT = `${API_PREFIX_V1}projects/delete-project/`;
export const API_CREATE_PROJECT = `${API_PREFIX_V1}projects/create-projects`;
export const API_UPDATE_PROJECT = `${API_PREFIX_V1}projects/update-project/`;
export const API_APPROVE_PROJECT = `${API_PREFIX_V1}projects/approve/`;
export const API_REJECT_PROJECT = `${API_PREFIX_V1}projects/reject/`;
export const API_PROJECT_BULK_IMPORT = `${API_PREFIX_V1}projects/project-bulk-import`;

// Milestones (under projects)
const MILESTONES_BASE = `${API_PREFIX_V1}projects/milestones`;
export const API_GET_MILESTONES_BY_PROJECT = `${MILESTONES_BASE}`;
export const API_GET_MILESTONE = `${MILESTONES_BASE}/`;
export const API_CREATE_MILESTONE = MILESTONES_BASE;
export const API_UPDATE_MILESTONE = `${MILESTONES_BASE}/`;
export const API_PATCH_MILESTONE_ORDER = `${MILESTONES_BASE}/`;
export const API_DELETE_MILESTONE = `${MILESTONES_BASE}/`;
export const API_MILESTONES_LIST = `${MILESTONES_BASE}/list`;

export const API_GET_BILLING_CYCLE_LIST = `${API_PREFIX_V1}billing-cycle/billing-cycle-list`;
export const API_CREATE_BILLING_CYCLE = `${API_PREFIX_V1}billing-cycle/create-billing-cycle`;
export const API_UPDATE_BILLING_CYCLE = `${API_PREFIX_V1}billing-cycle/update/`;
export const API_DELETE_BILLING_CYCLE = `${API_PREFIX_V1}billing-cycle/delete-billing-cycle/`;
export const API_GET_BILLING_CYCLE_SUMMARY = `${API_PREFIX_V1}billing-cycle/billing-cycle-summary`;
export const API_GET_BILLING_DETAILS = `${API_PREFIX_V1}billing-cycle/billing-cycle-details`;

export const API_GET_ALL_VENDOR_LIST = `${API_PREFIX_V1}vendor/get-vendor-list`;
export const API_GET_VENDOR_LIST = `${API_PREFIX_V1}vendor/vendor-list`;
export const API_CREATE_VENDOR = `${API_PREFIX_V1}vendor/create-vendor`;
export const API_UPDATE_VENDOR = `${API_PREFIX_V1}vendor/update-vendor/`;

export const API_GET_ALL_ACCOUNTS_LIST = `${API_PREFIX_V1}accounts/get-account-list`;
export const API_GET_ACCOUNT_LIST = `${API_PREFIX_V1}accounts/account-list`;
export const API_CREATE_ACCOUNT = `${API_PREFIX_V1}accounts/create-account`;
export const API_UPDATE_ACCOUNT = `${API_PREFIX_V1}accounts/update-account/`;
export const API_DELETE_ACCOUNT = `${API_PREFIX_V1}accounts/delete-account/`;
export const API_GET_ACCOUNT_LIST_BY_ENTITY = `${API_PREFIX_V1}accounts/get-accounts/`;

export const API_GET_ACTIVITY_LOG = `${API_PREFIX_V1}activity-log/`;
export const API_GET_DOCUMENTS = `${API_PREFIX_V1}documents/get-document-list/`;
// Documents for a parent record (staff/account/vendor/project) across all document types.
export const API_GET_DOCUMENT_LIST = `${API_PREFIX_V1}documents/list`;
export const API_GET_DOCUMENT_SIGNED_URL = `${API_PREFIX_V1}documents/get-signed-url/`;
export const API_UPLOAD_DOCUMENT = `${API_PREFIX_V1}documents/upload-staff-document`;
export const API_DELETE_DOCUMENT = `${API_PREFIX_V1}documents/delete/`;

export const API_GET_STAFF_ALLOCATION = `${API_PREFIX_V1}staff-assignment/`;
export const API_POST_ALLOCATION_REPORT = `${API_PREFIX_V1}staff-assignment/allocation-report`;
export const API_CREATE_STAFF_ASSIGNMENT = `${API_PREFIX_V1}staff-assignment/create-staff-assignment`;
export const API_UPDATE_STAFF_ASSIGNMENT = `${API_PREFIX_V1}staff-assignment/update-staff-assignment`;
export const API_SOFT_DELETE_STAFF_PROJECT = `${API_PREFIX_V1}staff-assignment/soft-delete-staff-project`;
export const API_GET_STAFF_ASSIGNMENT_SUMMARY = `${API_PREFIX_V1}staff-assignment/staff-assignment-summary`;
export const API_UPSERT_STAFF_LOP = `${API_PREFIX_V1}staff-assignment/staff-lop`;
export const API_GET_STAFF_LOP_LIST = `${API_PREFIX_V1}staff-assignment/staff-lop/list`;

export const API_REPORT_METADATA = `${API_PREFIX_V1}reports/metadata`;
export const API_REPORT_QUERY = `${API_PREFIX_V1}reports/query`;
export const API_SAVED_REPORTS = `${API_PREFIX_V1}reports/saved`;
export const API_GET_REPORTS_TABLE_PREFERENCES =
  `${API_PREFIX_V1}reports/table-preferences/reports`;

export const API_SAVE_REPORTS_TABLE_PREFERENCES =
  `${API_PREFIX_V1}reports/table-preferences/reports`;

export const API_COMMON_GET_BY_MODULE = (module: string) => `${API_PREFIX_V1}master/${module}`;

export const API_GET_FOREX_LIST = `${API_PREFIX_V1}master/currency/exchange-rate/list`;
export const API_ADD_FOREX = `${API_PREFIX_V1}master/currency/exchange-rate`;
export const API_UPDATE_FOREX = `${API_PREFIX_V1}master/update-currency-exchange-rate/`;
export const API_DELETE_FOREX = `${API_PREFIX_V1}master/currency/exchange-rate/`;
export const API_LOOKUP_FOREX_RATE = `${API_PREFIX_V1}master/forex/rate`;

export const API_GET_SALES_LIST = `${API_PREFIX_V1}sales/list`;
export const API_GET_SALES_FILTERED = `${API_PREFIX_V1}sales/filter-options`;
export const API_CREATE_SALES = `${API_PREFIX_V1}sales/create`;
export const API_UPDATE_SALES = `${API_PREFIX_V1}sales/update/`;
export const API_DELETE_SALES = `${API_PREFIX_V1}sales/delete/`;
export const API_GET_DEAL_STAGE_ACTIVE = `${API_PREFIX_V1}deal-stage/all-active`;
export const API_GET_ALL_DEAL_STAGES = `${API_PREFIX_V1}deal-stage/all`;
export const API_DEAL_STAGE_BASE = `${API_PREFIX_V1}deal-stage`;
export const API_DEAL_SUB_STAGE_BASE = `${API_PREFIX_V1}deal-sub-stage`;
export const API_GET_DEAL_SUB_STAGE_BY_STAGE = `${API_PREFIX_V1}deal-sub-stage/list-by-stage/`;

export const API_IT_ASSET_LIST = `${API_PREFIX_V1}it-assets/list`;
export const API_IT_ASSET_OPTIONS = `${API_PREFIX_V1}it-assets/options`;
export const API_IT_ASSET_UPDATE = `${API_PREFIX_V1}it-assets/staff/`;
export const API_IT_ASSET_EXPORT = `${API_PREFIX_V1}it-assets/export`;

export const API_GET_USERS = `${API_PREFIX_V1}auth/users`;
export const API_CREATE_USER = `${API_PREFIX_V1}auth/create/user-login`;
export const API_UPDATE_USER = `${API_PREFIX_V1}auth/users/`;
export const API_DELETE_USER = `${API_PREFIX_V1}auth/users/`;
export const API_GET_ROLES = `${API_PREFIX_V1}auth/roles`;

export const API_GET_ROLE_LIST = "/roles";
export const API_CREATE_ROLE = "/roles";
export const API_UPDATE_ROLE = "/roles/";
export const API_DELETE_ROLE = "/roles/";
export const API_GET_PERMISSIONS = "/permissions";




// ===== AI CANDIDATE SCREENING & RANKING (plan.md §9) =====
const CANDIDATE_SCREENING_BASE = `${API_PREFIX_V1}candidate-screening`;

// Job Descriptions
export const API_CS_CREATE_JD = `${CANDIDATE_SCREENING_BASE}/job-description`;
export const API_CS_BULK_UPLOAD_JD = `${CANDIDATE_SCREENING_BASE}/job-description/bulk-upload`;
export const API_CS_LIST_JD = `${CANDIDATE_SCREENING_BASE}/job-description`;
export const API_CS_GET_JD = `${CANDIDATE_SCREENING_BASE}/job-description/`; // + :id
export const API_CS_UPDATE_JD = `${CANDIDATE_SCREENING_BASE}/job-description/`; // + :id
export const API_CS_DELETE_JD = `${CANDIDATE_SCREENING_BASE}/job-description/`; // + :id
export const API_CS_JD_SKILLS = (id: string) =>
  `${CANDIDATE_SCREENING_BASE}/job-description/${id}/skills`;

// Candidates
export const API_CS_LIST_CANDIDATES = `${CANDIDATE_SCREENING_BASE}/candidate`;
export const API_CS_UPLOAD_CANDIDATE = `${CANDIDATE_SCREENING_BASE}/candidate/upload`;
export const API_CS_BATCH_UPLOAD_CANDIDATE = `${CANDIDATE_SCREENING_BASE}/candidate/batch-upload`;
export const API_CS_DELETE_CANDIDATE = `${CANDIDATE_SCREENING_BASE}/candidate/`; // + :id

// Screening / scoring
export const API_CS_SCREEN = `${CANDIDATE_SCREENING_BASE}/screen`;
export const API_CS_RESCORE = `${CANDIDATE_SCREENING_BASE}/rescore`;
export const API_CS_RESULTS = `${CANDIDATE_SCREENING_BASE}/results/`; // + :jobDescriptionId
export const API_CS_RESULTS_EXPORT = (jobDescriptionId: string) =>
  `${CANDIDATE_SCREENING_BASE}/results/${jobDescriptionId}/export`;

// Rule engine
export const API_CS_RULES = `${CANDIDATE_SCREENING_BASE}/rules`;
export const API_CS_RULE = `${CANDIDATE_SCREENING_BASE}/rules/`; // + :id (PUT / DELETE)

// AI configuration
export const API_CS_AI_CONFIG = `${CANDIDATE_SCREENING_BASE}/ai-config`;
export const API_CS_AI_CONFIG_TEST = `${CANDIDATE_SCREENING_BASE}/ai-config/test`;


export const API_STAFF_ACTIVITY_LOG = "/staff/activity-log/"; // + id

// Document Type
export const API_GET_ALL_DOCUMENT_TYPE_LIST = `${API_PREFIX_V1}document-type/list`;
export const API_GET_ALL_DOCUMENT_TYPE_ACTIVELIST = `${API_PREFIX_V1}document-type/all-active`;

export const API_GET_DOCUMENT_TYPE_DETAILS = `${API_PREFIX_V1}document-type/details/`; // + id
export const API_CREATE_DOCUMENT_TYPE = `${API_PREFIX_V1}document-type/create`;
export const API_UPDATE_DOCUMENT_TYPE = `${API_PREFIX_V1}document-type/update/`; // + id
export const API_DELETE_DOCUMENT_TYPE = `${API_PREFIX_V1}document-type/delete/`; // + id
export const API_DOCUMENT_TYPE_ACTIVITY_LOG = `${API_PREFIX_V1}document-type/activity-log/`; // + id

// Document Sub Type
export const API_GET_ALL_DOCUMENT_SUB_TYPE_LIST = `${API_PREFIX_V1}document-sub-type/list`;
export const API_GET_ALL_DOCUMENT_SUB_TYPE_LIST_BY_DOCUMENT_TYPE = `${API_PREFIX_V1}document-sub-type/list-by-type`; // + documentTypeId (deprecated: sub-types are no longer scoped to a type)
export const API_GET_ACTIVE_DOCUMENT_SUB_TYPE_LIST = `${API_PREFIX_V1}document-sub-type/list-all`;
export const API_GET_DOCUMENT_SUB_TYPE_DETAILS = `${API_PREFIX_V1}document-sub-type/details/`; // + id
export const API_CREATE_DOCUMENT_SUB_TYPE = `${API_PREFIX_V1}document-sub-type/create`;
export const API_UPDATE_DOCUMENT_SUB_TYPE = `${API_PREFIX_V1}document-sub-type/update/`; // + id
export const API_DELETE_DOCUMENT_SUB_TYPE = `${API_PREFIX_V1}document-sub-type/delete/`; // + id
export const API_DOCUMENT_SUB_TYPE_ACTIVITY_LOG = `${API_PREFIX_V1}document-sub-type/activity-log/`; // + id

// Release notes
export const API_GET_LATEST_UNSEEN_RELEASE = `${API_PREFIX_V1}releases/latest-unseen`;
export const API_MARK_RELEASE_VIEWED = `${API_PREFIX_V1}releases/mark-viewed`;
export const API_RELEASES = `${API_PREFIX_V1}releases`;
export const API_GET_STAFF_TABLE_PREFERENCES =
  `${API_PREFIX_V1}staffs/table-preferences/staff`;

export const API_SAVE_STAFF_TABLE_PREFERENCES =
  `${API_PREFIX_V1}staffs/table-preferences/staff`;
export const API_GET_IT_ASSET_TABLE_PREFERENCES =
  `${API_PREFIX_V1}it-assets/table-preferences`;

export const API_SAVE_IT_ASSET_TABLE_PREFERENCES =
  `${API_PREFIX_V1}it-assets/table-preferences`;
export const API_GET_PROJECT_TABLE_PREFERENCES =
  `${API_PREFIX_V1}projects/table-preferences/project`;

export const API_SAVE_PROJECT_TABLE_PREFERENCES =
  `${API_PREFIX_V1}projects/table-preferences/project`;

export const API_GET_MILESTONE_TABLE_PREFERENCES =
  "api/v1/projects/milestones/table-preferences";

export const API_SAVE_MILESTONE_TABLE_PREFERENCES =
  "api/v1/projects/milestones/table-preferences";

export const API_GET_SALES_TABLE_PREFERENCES = (moduleKey: string) =>
  `${API_PREFIX_V1}sales/table-preferences/${moduleKey}`;

export const API_SAVE_SALES_TABLE_PREFERENCES = (moduleKey: string) =>
  `${API_PREFIX_V1}sales/table-preferences/${moduleKey}`;
